<template>
  <byted-button
    :class="[{ ['is-loading']: loading }, `common_popup_confirm`]"
    type="primary"
    :loading="loading"
    :disabled="disabled"
    @click="handleConfirm"
  >
    {{ $t('common_confirm') }}
  </byted-button>
</template>
<script>
import { defineComponent } from 'vue-demi';
const name = 'popup-confirm-button';
export default defineComponent({
  name,
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const handleConfirm = () => {
      emit('confirm');
    };
    return {
      handleConfirm,
    };
  },
});
</script>
<style lang="scss">
.common_popup_confirm {
  margin: 16px;
  width: calc(100% - 32px);
  &.is-loading {
    background-color: var(--ks-ref-color-primary-850);
    pointer-events: none;
  }
}
</style>
